import { createTheme } from '@mui/material'
// import blue from '@mui/material/colors/blue'
// import amber from '@mui/material/colors/amber'
import { grey, pink } from '@mui/material/colors'
import type {} from '@mui/x-date-pickers-pro/themeAugmentation'

export const Theme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: pink[400],
			contrastText: '#ffffff',
		},
		secondary: {
			main: grey[800],
		},
	},
	components: {
		MuiTableSortLabel: {
			defaultProps: {
				hideSortIcon: true,
			},
		},
		MuiTextField: {
			defaultProps: {
				size: 'small',
				variant: 'filled',
				margin: 'normal',
			},
		},
		MuiPickersTextField: {
			defaultProps: {
				variant: 'filled',
				size: 'small',
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					variants: [
						{
							props: { variant: 'contained', color: 'primary' },
							style: {
								backgroundSize: '200% auto',
								transition: '0.3s',
								backgroundImage:
									'linear-gradient(45deg, rgba(255,53,127,1) 0%,rgba(152,68,183,1) 51%, rgba(87,111,230,1) 100%)',
								'&:hover': {
									backgroundPosition: 'right center',
								},
							},
						},
					],
				},
			},
		},
	},
})

// export const _Theme = createTheme(
//   adaptV4Theme({
//     palette: {
//       primary: {
//         main: '#617577',
//         contrastText: '#ffffff',
//       },
//       secondary: {
//         main: '#37474f',
//       },
//     },
//     overrides: {
//       MuiButton: {
//         containedPrimary: {
//           color: '#ffffff',
//         },
//       },
//       MuiChip: {
//         sizeSmall: {
//           height: 20,
//         },
//       },
//       MuiDialogTitle: {
//         root: {
//           textAlign: 'center',
//           position: 'relative',
//           zIndex: 1,
//           '&::before': {
//             content: '""',
//             boxShadow: '0 0 20px 0 rgba(7,48,90,0.3)',
//             position: 'absolute',
//             top: 0,
//             bottom: 0,
//             left: 0,
//             right: 0,
//           },
//           '& h2': {
//             color: '#617577',
//             textTransform: 'uppercase',
//             fontSize: 14,
//           },
//         },
//       },
//       MuiDialogActions: {
//         root: {
//           // borderTop: 'solid 1px #D5D6D7',
//         },
//       },
//       // TableCell: {
//       //   cell: {
//       //     padding: 8,
//       //   },
//       // },
//       // EditCell: {
//       //   cell: {
//       //     padding: '0 8px',
//       //   },
//       // },
//       // TableSelectCell: {
//       //   cell: {
//       //     paddingLeft: 0,
//       //   },
//       //   checkbox: {
//       //     padding: 0,
//       //   },
//       // },
//       // TableSelectAllCell: {
//       //   cell: {
//       //     paddingLeft: 0,
//       //   },
//       //   checkbox: {
//       //     padding: 0,
//       //   },
//       // },
//       MuiTableCell: {
//         paddingCheckbox: {
//           // paddingLeft: 0,
//           '&$sizeSmall': {
//             paddingLeft: 0,
//           },
//         },
//       },
//       // TableGroupCell: {
//       //   cell: {
//       //     '& > div': {
//       //       backgroundColor: 'transparent',
//       //     },
//       //   },
//       // },
//       // Table: {
//       //   table: {
//       //     '& colgroup col:last-child': {
//       //       width: '100%',
//       //     },
//       //   },
//       // },
//       MuiTableSortLabel: {
//         root: {
//           fontSize: '12px',
//         },
//       },
//     },
//     props: {
//       MuiTableSortLabel: {
//         hideSortIcon: true,
//       },
//       MuiTextField: {
//         size: 'small',
//         variant: 'filled',
//         margin: 'normal',
//       },
//     },
//   })
// )
